'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var tbody = require('./tbody.js');
var trEmpty = require('./tr-empty.js');
var trError = require('./tr-error.js');
var trLoader = require('./tr-loader.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StandardTBody = ({ breakpoints , children , columnsLength , empty , emptyContent , emptyTrProps , error , errorContent , errorTrProps , loaderLabel , loaderTrProps , loading , look , ...tbodyProps })=>{
    return /*#__PURE__*/ React__default.default.createElement(tbody.TBody, _extends({}, tbodyProps, {
        breakpoints: breakpoints
    }), emptyContent && empty && !error && !loading && /*#__PURE__*/ React__default.default.createElement(trEmpty.TrEmpty, _extends({}, emptyTrProps, {
        breakpoints: breakpoints,
        colSpan: columnsLength,
        look: look
    }), emptyContent), error && errorContent && !empty && !loading && /*#__PURE__*/ React__default.default.createElement(trError.TrError, _extends({}, errorTrProps, {
        breakpoints: breakpoints,
        colSpan: columnsLength,
        look: look
    }), errorContent), !error && !empty && !!loaderLabel && loading && /*#__PURE__*/ React__default.default.createElement(trLoader.TrLoader, _extends({}, loaderTrProps, {
        breakpoints: breakpoints,
        colSpan: columnsLength,
        label: loaderLabel,
        look: look
    })), !error && !empty && !loading && children);
};

exports.StandardTBody = StandardTBody;
//# sourceMappingURL=standard-tbody.js.map
